exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-wrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\ninput {\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  border: 0;\n  background: transparent;\n  border-bottom: 1px solid #393939;\n  outline: none;\n  color: #fff;\n}\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n.arrow-wrapper {\n  position: absolute;\n  top: 13px;\n  right: 0;\n}\n.arrow-up {\n  width: 0;\n  height: 0;\n  margin-bottom: 5px;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-bottom: 6px solid #fff;\n  cursor: pointer;\n}\n.arrow-down {\n  width: 0;\n  height: 0;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 6px solid #fff;\n  cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/NightKey/CMS/nightkey-cms/src/app/shared/spinner/spinner.component.less
// module id = ../../../../../src/app/shared/spinner/spinner.component.less
// module chunks = main